// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"a1f51ddf","223":"de8b99c5","453":"d4bd53b8","846":"716185cf","893":"d79eea9e","916":"423cc087","977":"04d88269"}[chunkId] + ".chunk.js";
};